/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSubjectMessageDTO
 */
export interface SendSubjectMessageDTO {
    /**
     * 
     * @type {string}
     * @memberof SendSubjectMessageDTO
     */
    subjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SendSubjectMessageDTO
     */
    message?: string | null;
}

export function SendSubjectMessageDTOFromJSON(json: any): SendSubjectMessageDTO {
    return SendSubjectMessageDTOFromJSONTyped(json, false);
}

export function SendSubjectMessageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSubjectMessageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SendSubjectMessageDTOToJSON(value?: SendSubjectMessageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subjectId': value.subjectId,
        'message': value.message,
    };
}

